import { get, post } from '../axios'

// 查询设置
export function theme_query_get(map, option) {
  return get(`${process.env.VUE_APP_NAV}/theme/query`, map, option).then(
    response => response
  )
}

// 保存设置
export function theme_save_post(map, option) {
  return post(`${process.env.VUE_APP_NAV}/theme/save`, map, option).then(
    response => response
  )
}

export function homepage_strategy_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_NAV}/homepage/new/strategy/list`,
    map,
    option
  ).then(response => response)
}

export function tobpop_list_post(map, option) {
  return post(`${process.env.VUE_APP_NAV}/topPop/query`, map, option).then(
    response => response
  )
}

export function tobBar_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_NAV}/commonConfig/topbar/list`,
    map,
    option
  ).then(response => response)
}
